import { useEffect, useRef } from 'react'

export function useInitialFocus() {
  const initialFocus = useRef<HTMLElement>(null)
  useEffect(() => {
    initialFocus.current.focus()
  }, [])
  return initialFocus
}
